import { Component, Input, AfterViewInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-yandex-floor-ad',
  template: ''
})
export class YandexFloorAdComponent implements AfterViewInit {
  @Input() blockId: string;
  @Input() platformType?: string;

  constructor(private doms: DomSanitizer) {}

  safeCss(style) {
    return this.doms.bypassSecurityTrustStyle(style);
  }

  ngAfterViewInit() {
    // @ts-ignore
    window.yaContextCb.push(() => {
      // @ts-ignore
      Ya.Context.AdvManager.render({
        blockId: this.blockId,
		type: "floorAd",
        platform: this.platformType,
      });
    });
  }

}
